/* eslint-disable @typescript-eslint/no-explicit-any */
import { getPartnerId } from 'core/singleton'
import { lazyWithPreload } from 'core/util/preload'

const PageInnisfree = lazyWithPreload(() => import('custom/Innisfree/container/Page/PageInnisfree'))
const PageInnisfreeCuration = lazyWithPreload(
  () => import('custom/Innisfree/container/Page/PageCuration'),
)
const PageInnisfreeSchedules = lazyWithPreload(
  () => import('custom/Innisfree/container/Page/PageSchedules'),
)

interface PartnersRouterProps {
  children: React.ReactNode
  path: string
  props?: any
}

const PartnersRouter: React.FC<PartnersRouterProps> = ({ path, children, props }) => {
  const partnerId = getPartnerId()

  if (partnerId === 'innisfree_test' || partnerId === 'collection_m') {
    switch (path) {
      case '/':
        return <PageInnisfree />
      case '/curation':
        return <PageInnisfreeCuration id={props.match.params.id} title={props.match.params.title} />
      case '/schedule':
        return <PageInnisfreeSchedules />
    }
  }

  return <>{children}</>
}

export default PartnersRouter
